import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AppCommonModule } from '@app/shared/common/app-common.module';
import { CollapsiblePanelComponent } from './collapsible-panel/collapsible-panel.component';
import { ListPropertiesFilterComponent } from './list-properties-filter/list-properties-filter.component';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { SelectorComponent } from './selector/selector.component';
import { SpinnerComponentComponent } from './spinner-component/spinner-component.component';
import { OperationListIndicatorComponent } from './operation-list-indicator/operation-list-indicator.component';
import { PatientNameComponent } from './patient-name/patient-name.component';
import { ConsultantAbbreviationComponent } from './consultant-abbreviation/consultant-abbreviation.component';
import { UtilisationComponent } from './utilisation/utilisation.component';
import { UtilisationValueComponent } from './utilisation/utilisation-value/utilisation-value.component';
import { SpecialityImprovementSummaryItemComponent } from './speciality-improvement-summary-item/speciality-improvement-summary-item.component';
import { SummaryItemValueComponent } from './speciality-improvement-summary-item/summary-item-value/summary-item-value.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { TextMaskModule } from 'angular2-text-mask';
import { ListSearchBoxComponent } from './list-search-box/list-search-box.component';
import { CalendarPickerComponent } from './calendar-picker/calendar-picker.component';
import { SemanticTimeComponent } from './semantic-time/semantic-time.component';
import { ProcedureNameComponent } from './procedure-name/procedure-name.component';
import { ExpandableRowPaneComponent } from './expandable-row-pane/expandable-row-pane.component';
import { ChevronComponent } from './chevron/chevron.component';
import { PreassessedIndicatorComponent } from './preassessed-indicator/preassessed-indicator.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { WeeksWaitingComponent } from './weeks-waiting/weeks-waiting.component';
import { PatientTrackingListFiltersComponent } from './patient-tracking-list-filters/patient-tracking-list-filters.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';

@NgModule({
    imports: [CommonModule, FormsModule, AppCommonModule, TextMaskModule],
    declarations: [
        CollapsiblePanelComponent,
        ListPropertiesFilterComponent,
        ToggleSwitchComponent,
        ProgressBarComponent,
        SelectorComponent,
        SpinnerComponentComponent,
        OperationListIndicatorComponent,
        PatientNameComponent,
        ConsultantAbbreviationComponent,
        UtilisationComponent,
        UtilisationValueComponent,
        SpecialityImprovementSummaryItemComponent,
        SummaryItemValueComponent,
        PhoneInputComponent,
        ListSearchBoxComponent,
        CalendarPickerComponent,
        SemanticTimeComponent,
        ProcedureNameComponent,
        ExpandableRowPaneComponent,
        ChevronComponent,
        PreassessedIndicatorComponent,
        CheckboxComponent,
        PatientTrackingListFiltersComponent,
        WeeksWaitingComponent,
        RadioButtonComponent
    ],
    exports: [
        CollapsiblePanelComponent,
        ListPropertiesFilterComponent,
        ToggleSwitchComponent,
        ProgressBarComponent,
        SelectorComponent,
        SpinnerComponentComponent,
        OperationListIndicatorComponent,
        PatientNameComponent,
        ConsultantAbbreviationComponent,
        UtilisationComponent,
        UtilisationValueComponent,
        SpecialityImprovementSummaryItemComponent,
        SummaryItemValueComponent,
        PhoneInputComponent,
        ListSearchBoxComponent,
        CalendarPickerComponent,
        SemanticTimeComponent,
        ProcedureNameComponent,
        ExpandableRowPaneComponent,
        ChevronComponent,
        CheckboxComponent,
        PatientTrackingListFiltersComponent,
        WeeksWaitingComponent
    ]
})
export class SharedComponentsModule {}



// WEBPACK FOOTER //
// ./src/app/shared/components/shared-components.module.ts